(function () {
  'use strict';

  function productUrl(path, variantId, token) {
    const url = new URL(path, 'https://ceragemus.com');
    url.search = '';
    url.hash = '';
    url.searchParams.set('variant', String(variantId));
    if (token === 'NES38') url.searchParams.set('token', token);
    return url.pathname + url.search;
  }

  function confirmedPrice(result, variant, handle, campaign, now) {
    if (!result || !variant.available || (campaign.ignoreDates !== true && !(now >= Date.parse(campaign.start) && now < Date.parse(campaign.end)))
      || !result.isDiscountedByOffer || result.sellingPlan || result.productHandle !== handle
      || String(result.variantId) !== String(variant.id) || result.promotionToken !== campaign.token
      || result.offerToken !== campaign.offer || result.percentage !== 30
      || result.originalPrice !== variant.price || !Number.isInteger(result.discountedPrice)
      || result.discountedPrice < 0 || result.discountedPrice >= variant.price
      || Math.abs(result.originalPrice - result.discountedPrice - result.originalPrice * 0.3) > 1) return null;
    return result.discountedPrice;
  }

  function renderResult(input, campaign) {
    const info = input?.productInfo;
    if (!info?.price || input.offerToken !== campaign.offer || !info.available) return null;
    // The configured offer token identifies HLTH. Use the app's amount, never a URL-derived price.
    return { productHandle: info.productHandle, variantId: info.variantId, sellingPlan: info.sellingPlanId,
      originalPrice: info.price.original, discountedPrice: info.price.discounted,
      promotionToken: campaign.token, offerToken: input.offerToken, percentage: 30, isDiscountedByOffer: true };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { productUrl, confirmedPrice, renderResult };
  if (typeof window === 'undefined' || window.HlthLanding) return;
  window.HlthLanding = true;
  const instances = new Map();
  const registered = new WeakSet();

  function registerRenderer() {
    const pricing = window.discountNinja?.api?.strikethroughPricing;
    if (!pricing?.setBeforeRender || registered.has(pricing)) return;
    pricing.setBeforeRender(input => {
      instances.forEach(instance => instance.onRender(input));
      return input.defaultHtml;
    });
    registered.add(pricing);
  }

  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const campaign = JSON.parse(root.querySelector('[data-hlth-campaign]').textContent);
    const arrivalToken = new URL(window.location.href).searchParams.get('token');
    let token = arrivalToken === campaign.token ? arrivalToken : '';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: root.dataset.currency
    });
    const cards = [...root.querySelectorAll('[data-hlth-product]')].map(element => {
      const data = JSON.parse(element.querySelector('[data-hlth-product-data]').textContent);
      return { element, data, variant: data.variants.find(item => String(item.id) === element.dataset.laDnProductVariant), result: null };
    });

    function updateLink(card) {
      const href = productUrl(card.data.url, card.variant.id, token);
      card.element.querySelectorAll('[data-hlth-product-link]').forEach(link => { link.href = href; });
    }

    function renderPrice(card) {
      const amount = confirmedPrice(card.result, card.variant, card.data.handle, campaign, Date.now());
      const active = amount !== null;
      const regular = card.element.querySelector('[data-hlth-regular]');
      regular.hidden = active;
      regular.querySelector('[data-hlth-regular-amount]').textContent = card.variant.money;
      card.element.querySelector('[data-hlth-discount]').hidden = !active;
      card.element.querySelector('[data-hlth-original]').textContent = card.variant.money;
      card.element.querySelector('[data-hlth-discounted]').textContent = active ? money.format(amount / 100) : '';
      card.element.querySelector('[data-hlth-sold-out]').hidden = card.variant.available;
    }

    function refreshEngine() {
      document.dispatchEvent(new CustomEvent('la:dn:collection:updated'));
    }

    root.addEventListener('change', event => {
      if (!event.target.matches('[data-hlth-variant]')) return;
      const card = cards.find(item => item.element.contains(event.target));
      const variant = card?.data.variants.find(item => String(item.id) === event.target.value);
      if (!variant) return;
      card.variant = variant;
      card.result = null;
      const { element } = card;
      element.dataset.laDnProductVariant = String(variant.id);
      element.dataset.laDnProductPrice = String(variant.price);
      element.dataset.laDnProductCompareAtPrice = String(variant.compareAt || variant.price);
      element.dataset.laDnProductAvailable = String(variant.available);
      const image = element.querySelector('[data-hlth-image]');
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
        image.alt = variant.imageAlt;
      }
      element.querySelector('[data-hlth-selected-color]').textContent = variant.title;
      // Replace the pricing marker so an in-flight render cannot write into the new variant's root.
      const previous = element.querySelector('[data-la-dn-price]');
      const price = document.createElement('span');
      price.setAttribute('data-la-dn-price', '');
      price.textContent = variant.money;
      previous.replaceWith(price);
      updateLink(card);
      renderPrice(card);
      refreshEngine();
    }, options);

    document.addEventListener('la:dn:product:discount:calculated', event => {
      const result = event.detail?.data?.[0];
      cards.forEach(card => {
        if (result?.productHandle !== card.data.handle || String(result.variantId) !== String(card.variant.id)) return;
        card.result = result;
        if (confirmedPrice(result, card.variant, card.data.handle, campaign, Date.now()) !== null) {
          token = campaign.token;
          cards.forEach(updateLink);
        }
        renderPrice(card);
      });
    }, options);
    document.addEventListener('la:dn:api:ready', refreshEngine, options);
    document.addEventListener('la:dn:promotions:loaded', () => {
      cards.forEach(card => { card.result = null; renderPrice(card); });
    }, options);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) cards.forEach(renderPrice);
    }, options);
    cards.forEach(card => { updateLink(card); renderPrice(card); });
    // Clear a displayed benefit at the boundary, even if the page stays open overnight.
    const timer = window.setInterval(() => cards.forEach(renderPrice), 30000);
    instances.set(root, {
      destroy() { controller.abort(); window.clearInterval(timer); },
      onRender(input) {
        cards.forEach(card => {
          const info = input.productInfo;
          if (info?.productHandle !== card.data.handle || String(info.variantId) !== String(card.variant.id)) return;
          card.result = renderResult(input, campaign);
          if (confirmedPrice(card.result, card.variant, card.data.handle, campaign, Date.now()) !== null) {
            token = campaign.token;
            cards.forEach(updateLink);
          }
          renderPrice(card);
        });
      }
    });
    registerRenderer();
    if (window.discountNinja?.api) refreshEngine();
  }

  function scan() { document.querySelectorAll('[data-hlth-landing]').forEach(mount); }
  document.addEventListener('la:dn:api:ready', registerRenderer);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && instances.size) window.location.reload();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
